"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var rxjs_1 = require("rxjs");
require("./spinner.css");
var Spinner = function (props) {
    var _a;
    var _b = React.useState((0, function_1.pipe)(O.some(props), O.filter(function (p) { return p.type === 'countDown'; }), O.chainNullableK(function (p) { return p.value; }))), count = _b[0], setCount = _b[1];
    var counterSub = {
        subscription: O.none,
    };
    React.useEffect(function () {
        (0, function_1.pipe)(O.some(props), O.filter(function (p) { return p.type === 'countDown'; }), O.chainNullableK(function (p) { return p.value; }), O.map(function (v) {
            counterSub.subscription = O.some((0, rxjs_1.interval)(1000).subscribe(function (_) {
                return setCount(function (prevState) {
                    return (0, function_1.pipe)(prevState, O.chain(function (c) { return (c !== 0 ? O.some(c - 1) : O.some(v)); }));
                });
            }));
        }));
        return function () {
            (0, function_1.pipe)(counterSub.subscription, O.filter(function (s) {
                return !s.closed;
            }), O.map(function (s) { return s.unsubscribe(); }));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return ((0, jsx_runtime_1.jsxs)("span", __assign({ className: (0, clsx_1.default)('spinner', { borderless: props.borderless ? true : false }), css: (0, react_1.css)(props.style) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('loader', "loader-size-".concat((_a = props.size) !== null && _a !== void 0 ? _a : 'std')) }, { children: (0, jsx_runtime_1.jsxs)("svg", __assign({ className: "circular-loader", viewBox: "25 25 50 50" }, { children: [(0, jsx_runtime_1.jsx)("circle", { className: (0, clsx_1.default)('loader-x', props.type === 'countDown' ? 'loader-x-countdown' : 'loader-x-default'), cx: "50", cy: "50", r: "20", strokeWidth: "1" }), (0, jsx_runtime_1.jsx)("circle", { className: "loader-path", cx: "50", cy: "50", r: "20", fill: "none", strokeWidth: "2" })] })) })), (0, jsx_runtime_1.jsx)("div", { className: "profile-main-loader" }), (0, function_1.pipe)(count, (0, Option_1.map)(function (c) { return (0, jsx_runtime_1.jsx)("span", __assign({ className: "countdown-number" }, { children: c })); }), O.toNullable)] })));
};
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map